module.exports = __webpack_public_path__ + "static/media/fo.7dc70ebf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/fo.svg
// module id = 115
// module chunks = 0